import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import { CloseOutlined } from '@ant-design/icons';
import { StyledModalWrapper } from './styles';
import { ModalContext } from '../../context/modalContext';

function GeneralModal({ ...props }) {
  const {
    modal, handleModal, modalContent, hideCloseBtn, classes,
  } =
    useContext(ModalContext);

  if (modal) {
    return createPortal(
      <StyledModalWrapper onClick={() => handleModal()}>
        <div onClick={(e) => e.stopPropagation()} className="modal-general">
          {hideCloseBtn ? null : (
            <div onClick={() => handleModal()} className={`close ${classes}`}>
              <CloseOutlined />
            </div>
          )}
          {modalContent}
        </div>
      </StyledModalWrapper>,
      document.getElementById('modal-root'),
    );
  }
  return null;
}

export default GeneralModal;
